













import { Vue, Component, Watch } from 'vue-property-decorator'
import { Container, Logo, Button, BackButton } from '../atoms/'
import { SocialBox, RegisterTermsAndCondition, EmailInputGroup } from '../molecules'
import {
  REGISTER_MODULE,
  EMAIL_SERVER_ERROR,
  SOCIAL_REGISTER,
  RESET_EMAIL_ERROR,
  GET_PROVIDER_INFO,
  PROVIDER,
  DISPLAY_NAME
} from '../../store/modules/register/constant'
import { required, email } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { APP_MODULE, TRANSLATE } from '../../store/modules/app/constant'
import translate from '@/language'

@Component({
  components: {
    Container,
    BackButton,
    Button,
    Logo,
    SocialBox,
    RegisterTermsAndCondition,
    EmailInputGroup
  },
  validations: {
    email: {
      required,
      email
    }
  },
  computed: {
    ...mapGetters(REGISTER_MODULE, [EMAIL_SERVER_ERROR, PROVIDER, DISPLAY_NAME]),
    ...mapGetters(APP_MODULE, [TRANSLATE])
  },
  methods: {
    ...mapActions(REGISTER_MODULE, [SOCIAL_REGISTER, RESET_EMAIL_ERROR, GET_PROVIDER_INFO])
  }
})
export default class EmailBinding extends Vue {
  private email?: string = ''
  private disableFormSubmit = false

  @Watch('email')
  onEmailChange() {
    (this as any)[RESET_EMAIL_ERROR]()
    this.$v.email.$touch()
  }

  mounted() {
    const challenge = this.$route?.query?.challenge
    if (this.$route?.query?.email) {
      this.email = unescape(this.$route?.query?.email.toString())
    }
    ;(this as any)[RESET_EMAIL_ERROR]()
    this.$nextTick(() => {
      this.$v.$reset()
    })
    return (this as any)[GET_PROVIDER_INFO](challenge)
  }
  get emailError(): string {
    const { email: emailError } = this.$v
    if ((this as any)[EMAIL_SERVER_ERROR]) {
      return (this as any)[EMAIL_SERVER_ERROR]
    }
    if (emailError.$error) {
      if (!emailError.required) {
        return translate('', 'error-email-required')
      } else if (!emailError.email) {
        return translate('', 'error-email-invalid')
      }
    }
    return ''
  }
  get isEmailError(): boolean {
    return this.emailError !== ''
  }
  get provider(): string {
    return (this as any)[PROVIDER]
  }
  get displayName() {
    return (this as any)[DISPLAY_NAME]
  }
  get formError(): boolean {
    return this.$v.$invalid || this.isEmailError
  }

  async doSocialRegister() {
    this.$v.$touch()
    if (!this.formError) {
      const payload = {
        email: this.email,
        challenge: this.$route?.query?.challenge
      }
      await (this as any)[SOCIAL_REGISTER](payload)
    }
  }
}
